import { SalvLabel } from '@salvapp/ui-components';
import React, { CSSProperties } from 'react';
import './NavigationCard.scss';
import { Link, To } from 'react-router-dom';
import baseImage1 from 'src/assets/img/configuration/base1.png';
import baseImage2 from 'src/assets/img/configuration/base2.png';
import baseImage3 from 'src/assets/img/configuration/base3.png';
import baseImage4 from 'src/assets/img/configuration/base4.png';
import baseImage5 from 'src/assets/img/configuration/base5.png';
import baseImage6 from 'src/assets/img/configuration/base6.png';
import baseImage7 from 'src/assets/img/configuration/base7.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface Props {
  title: string;
  description: string;
  to: To;
  type?: string;
  inDevelopment?: boolean;
  className?: string;
  image: {
    base: any;
    icon: IconDefinition;
    iconStyle?: CSSProperties;
  };
}

const NavigationCard = ({ inDevelopment, title, description, to, image, className = '' }: Props) => {
  const { base, icon, iconStyle } = image;

  return (
    <Link
      to={to}
      className={'navigation-card'}
      style={{ display: 'flex', flexDirection: 'column', opacity: inDevelopment ? 0.7 : 1 }}
      aria-label={title}
    >
      <div className={'navigation-image'}>
        <img className={'navigation-image-base'} src={base} alt={title} />
        <FontAwesomeIcon
          icon={icon}
          className={'navigation-image-icon'}
          style={{
            marginLeft: '32px',
            marginBottom: '24px',
            ...iconStyle,
          }}
        />
      </div>
      <div
        className={'navigation-text ' + className}
        style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
      >
        <div>
          <div className={'navigation-title'} style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <span>{title}</span>
            {inDevelopment && <SalvLabel variant={'warning'}>Coming soon</SalvLabel>}
          </div>
          <div className={'navigation-description'}>{description}</div>
        </div>
      </div>
    </Link>
  );
};

export const BaseImage = {
  base1: baseImage1,
  base2: baseImage2,
  base3: baseImage3,
  base4: baseImage4,
  base5: baseImage5,
  base6: baseImage6,
  base7: baseImage7,
};

export default NavigationCard;
